import React from "react";
import { X } from "lucide-react";

// Fallback image if the real one is missing or broken
const fallbackImg = "https://cdn-icons-png.flaticon.com/512/2662/2662503.png";

function ItemDetailModal({ selectedItem, setSelectedItem }) {
  if (!selectedItem) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn"
      onClick={() => setSelectedItem(null)}
    >
      <div
        className="
          bg-gradient-to-br from-[#FFF7E6] via-[#FFEBCF] to-[#F9DBA9]
          rounded-3xl p-8 w-[420px] shadow-2xl border border-[#FFD8A6]
          text-center relative animate-slideUp
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* CLOSE BUTTON */}
        <button
          className="absolute top-4 right-4 text-[#5A3E2B] hover:text-black transition"
          onClick={() => setSelectedItem(null)}
        >
          <X size={26} />
        </button>

        {/* IMAGE */}
        <div className="w-48 h-48 mx-auto bg-white rounded-2xl shadow-md border border-[#FFE1B4] p-4 flex items-center justify-center">
          <img
            src={selectedItem.image_url || fallbackImg} // <--- USE REAL IMAGE
            alt={selectedItem.name}
            className="w-full h-full object-contain"
            onError={(e) => { e.target.src = fallbackImg; }}
          />
        </div>

        {/* ITEM NAME */}
        <h2 className="text-2xl font-extrabold text-[#5A3E2B] mt-6 leading-tight">
          {selectedItem.name || selectedItem.product_name}
        </h2>

        {/* PRICE */}
        <p className="text-3xl font-bold text-[#FF8C42] mt-2">
          RM {selectedItem.price?.toFixed(2)}
        </p>

        {/* CATEGORY TAG */}
        <div
          className="
            mt-4 inline-block px-4 py-2 rounded-xl
            text-sm font-semibold text-[#5A3E2B]
            bg-white/70 border border-[#FFE1B4]
          "
        >
          {selectedItem.category}
        </div>

        {/* STORE INFO */}
        <p className="text-lg text-[#6F5A42] font-medium mt-4">
          Available at: <br/>
          <span className="text-[#38A3A5] font-bold text-xl">{selectedItem.store}</span>
        </p>

        {/* DESCRIPTION (Dynamic based on price) */}
        <p className="text-[#6F5A42] mt-6 text-sm leading-relaxed opacity-80">
          This item was selected by the AI optimizer because it offers a competitive price 
          within the <strong>{selectedItem.category}</strong> category at <strong>{selectedItem.store}</strong>.
        </p>
      </div>
    </div>
  );
}

export default ItemDetailModal;